import { render, staticRenderFns } from "./MoveGrid.vue?vue&type=template&id=5e8f3371&"
import script from "./MoveGrid.vue?vue&type=script&lang=js&"
export * from "./MoveGrid.vue?vue&type=script&lang=js&"
import style0 from "./MoveGrid.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports